// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__oXUAc","title":"styles_title__++BLY","table":"styles_table__Q3wFB"};